import { useSelector } from "react-redux";
import SponsorEditProfile from "./SponsorEditProfile";
import DashboardFooter from "../../../components/Footer";
import V2EditProfile from "./V2EditProfile";

function EditProfilePage() {
  const profileInfo = useSelector((state) => state.profileSlice.profile);
  const roles = profileInfo?.roles ?? [];
  const isIndividual = roles.some((role) =>
    ["mentee", "mentor"].includes(role),
  );

  return (
    <>
      {/* Individual profiles use the unified V2 editor. Sponsor-only profiles
          still use the legacy editor until sponsor editing is consolidated. */}
      {isIndividual && <V2EditProfile />}
      {roles.includes("sponsor") && !isIndividual && <SponsorEditProfile />}
      <DashboardFooter />
    </>
  );
}

export default EditProfilePage;
